
import React,{ useState,  useRef }  from 'react';
import {Segment,Header, Button} from 'semantic-ui-react'
import {v1 as uuid} from 'uuid'
import EditUser from '../EditUser/EditUser'


const AddKunde=({open,setOpen,db,baseHandleChange})=>{
    
    const usersDB=db.users
    const [user,setUser]=useState(
        {
            UID:uuid(),
            Vorname:'',
            Nachname:'',
            Strasse:'',
            Strasse2:'',
            PLZ:'',
            Ort:'',
            Land:'CH',
            mobil:'',
            Festnetz:'',
            email:'',
            attr:{},
            certified:'personal',
            Modus:'manuell',
            ShopId:'',


        }
    )


    const afterSubmit=()=>
    {
        setOpen(false)
        baseHandleChange({},{name:'Kunde',value:user.UID})
    }

    return (
        <>
        {
            (!open) ? '' :

            <Segment>
                <Header as="h3" content="fehlenden Kunden nacherfassen"/>
                <EditUser
                    user={user}
                    setUser={setUser}
                    afterSubmit={afterSubmit}
                    close={e=>setOpen(false)}
                    db={db}
                />
            </Segment>
        }
        </>   
    )
    
}
export default AddKunde

